// src/components/BackgroundLayer.tsx
import React from 'react';
import '../../../styles/globals.css';

interface Props {
  children?: React.ReactNode;
}

const BackgroundLayer: React.FC<Props> = ({ children }) => (
  <div
    className="relative min-h-screen overflow-hidden"
    style={{
      background: '#151515',
    }}
  >
    {/* Ellipse 1 (viewport-fixed) */}
    <div
      style={{
        position: 'absolute',
        width: '45vh',
        height: '45vh',
        left: '-128px',
        top: '50%',
        background: '#EE3C66',
        opacity: 0.4,
        filter: 'blur(100px)',
        pointerEvents: 'none',
        transform: 'translateY(-50%)',
      }}
    />

    {/* Ellipse 2, derecha arrina */}
    <div
      style={{
        position: 'fixed',
        width: '45vh',
        height: '45vh',
        right: '-48px',
        top: '-128px',
        background: '#EE3C66',
        opacity: 0.4,
        filter: 'blur(100px)',
        pointerEvents: 'none',
      }}
    />

    {/* Ellipse 3, abajo a la derecha */}
    <div
      style={{
        position: 'fixed',
        width: '30vw',
        height: '45vh',
        right: '40%',
        bottom: '-128px',
        background: '#EE3C66',
        opacity: 0.4,
        filter: 'blur(100px)',
        pointerEvents: 'none',
        transform: 'translateX(50%)',
      }}
    />

    {/* Ellipse 4, izquierda arriba */}
    <div
      style={{
        position: 'fixed',
        width: '30vw',
        height: '45vh',
        left: '40%',
        top: '-196px',
        background: '#EE3C66',
        opacity: 0.4,
        filter: 'blur(100px)',
        pointerEvents: 'none',
        transform: 'translateX(-50%)',
      }}
    />

    <div className="background">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    {/* Capa translúcida con imagen */}
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        backgroundImage: `url('/assets/imgs/background.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.03, // ajusta según lo translúcida que quieras
        zIndex: 1, // encima de las ellipses pero debajo del contenido
      }}
    />

    {/* El contenido de la aplicación */}
    <div className="relative z-10">{children}</div>
  </div>
);

export default BackgroundLayer;
